import React from 'react'
import { BaseUrl } from '../../../helper/BaseUrl';

export default function IDContent({ data }) {
  const sections = data?.sections || [];
  const handleScroll = (id) => {
    const element = document.getElementById(id);
    if (element) {
      const yOffset = -90;
      const y =
        element.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({
        top: y,
        behavior: "smooth",
      });
    }
  };

  const getShortText = (text, maxLength = 50) => {
    if (!text) return "";

    if (text.length <= maxLength) return text;

    const truncated = text.slice(0, maxLength);
    return truncated.slice(0, truncated.lastIndexOf(" ")) + "...";
  };

  return (
    <>
      <section className="int-detail-content">
        <div className="container">
          <div className="row">
            <div className="col-lg-3 col-md-12">
              <div className="int-left-content">
                <span>Overview:</span>
                <ul>
                  {sections.map((item, index) => (
                    <li key={index}>
                      <a href={`#section-${index}`} onClick={(event) => { event.preventDefault(); handleScroll(`section-${index}`); }}>
                        <div className="left-sec">
                          <img src={`/assets/images/overview-img${(index % 4) + 1}.webp`} alt="Icon" className="img-responsive" />
                        </div>
                        <div className="right-sec">   {getShortText(item.heading, 50)}</div>

                      </a>
                    </li>
                  ))}
                  <li >
                    <a href="#watch-video" onClick={(event) => { event.preventDefault(); handleScroll("watch-video"); }}>
                      <div className="left-sec">
                        <img src={`/assets/images/overview-img5.webp`} alt="Icon" className="img-responsive" />
                      </div>
                      <div className="right-sec">Explore Video Tutorial</div>
                    </a>
                  </li>
                  <li >
                    <a href={"/pricing"} >
                      <div className="left-sec">
                        <img src={`/assets/images/overview-img6.webp`} alt="Icon" className="img-responsive" />
                      </div>
                      <div className="right-sec">Explore Our Plans & Pricing</div>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-9 col-md-12">
              <div className="int-right-content">
                {sections.map((item, index) => (
                  <div key={index} className="section-block">
                    <div className="heading" id={`section-${index}`}>{item.heading}</div>
                    <div dangerouslySetInnerHTML={{ __html: item.description, }} />
                    {item.media_type === "image" && item.image && (
                      <div className="image-wrap">
                        <img src={`${BaseUrl}${item.image}`} alt={item.heading} className="img-responsive" loading="lazy" />  </div>)}
                    {item.media_type === "video" && item.video_link && (
                      <div className="iframe-wrap">
                        <iframe width="100%" height="500" src={item.video_link} title={item.heading} frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen></iframe>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
